import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M7.932 2.224a.12.12 0 0 1 .136 0c1.275.885 2.69 1.208 3.718 1.322.52.057.88.465.88.847v4.224c0 1.116-.899 2.288-2.1 3.253a10.5 10.5 0 0 1-1.684 1.102 6 6 0 0 1-.639.288 2 2 0 0 1-.24.072h-.007c-.021-.005-.096-.02-.237-.072a6 6 0 0 1-.639-.291 10.6 10.6 0 0 1-1.684-1.111c-.58-.468-1.117-1.005-1.503-1.573-.388-.57-.6-1.133-.6-1.668V4.393c0-.382.36-.79.88-.847 1.03-.114 2.444-.437 3.72-1.322m.896-1.095a1.46 1.46 0 0 0-1.656 0c-1.027.713-2.2.992-3.104 1.091C3.018 2.336 2 3.194 2 4.393v4.224c0 .889.35 1.711.83 2.418.482.709 1.122 1.34 1.77 1.861.649.523 1.326.953 1.903 1.254.288.151.559.274.796.361.215.08.47.156.701.156.229 0 .483-.075.699-.153a7 7 0 0 0 .796-.358A12 12 0 0 0 11.4 12.91c1.254-1.006 2.6-2.526 2.6-4.293V4.393c0-1.198-1.017-2.057-2.068-2.173-.904-.1-2.077-.378-3.104-1.091m1.643 6.01a.667.667 0 1 0-.942-.944L7.333 8.391l-.862-.862a.667.667 0 0 0-.942.942l1.333 1.334c.26.26.682.26.943 0z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }